<app-page-header [heading]="'Receipts'" [icon]="'fas fa-receipt'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">

    <!-- Customer, Date, Payment Type, Amount -->
    <div class="row">
        <div class="form-group col-lg-3">
            <label>Receipt No</label><span class="text-danger">&nbsp;*</span>
            <input type="text" [(ngModel)]="receipts.receipt_no" [readonly]="true" class="form-control" >
        </div>
        <div class="form-group col-lg-3">
            <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
            <ngx-select-dropdown
                    (change)="getCustomerInvoices()"
                    [(ngModel)]="customer_data"
                    [config]="utils.dropConfig({displayKey: 'CUSTOMER_NAME', placeholder: 'Select Customer', searchOnKey: 'CUSTOMER_NAME'})"
                    [multiple]="false"
                    [options]="customer_options"
                    class="form-control size"
                    name="customer">
            </ngx-select-dropdown>
        </div>

        <div class="form-group col-lg-3">
            <label>Date</label><span class="text-danger">&nbsp;*</span>
            <input type="date" [max]="getToday()" [(ngModel)]="receipts.receipt_date" class="form-control" />
        </div>

        <div class="form-group col-lg-3">
            <label>Receipt Type</label>
            <div class="col-12">
                <label class="checkbox-inline" *ngFor="let type of ['Cash','Bank','UPI','Cheque','Card']">
                    <input type="radio" name="receipt_type" [value]="type" [checked]="receipts.receipt_type==type" (click)="selectReceiptType(type)" />
                    &nbsp;&nbsp;{{ type }}
                </label>
            </div>
        </div>

        <div class="form-group col-lg-3">
            <label>Amount</label><span class="text-danger">&nbsp;*</span>
            <input type="text" maxlength="20" [(ngModel)]="receipts.receipt_amount" class="form-control" placeholder="Enter amount"
                   (keypress)="numberOnly($event)" (blur)="autoDistributeAmount()" name="receipts.receipt_amount" />
        </div>
    </div>

    <!-- Invoice Table -->
    <div *ngIf="invoices_list.length > 0" class="mt-4">
        <h4 class="list-header mb-3"><i class="fas fa-file-invoice"></i> Customer Invoices</h4>
        <table class="table table-bordered table-striped">
            <thead>
            <tr>
                <th>#</th>
                <th>Invoice No</th>
                <th>Date</th>
                <th class="text-right">Invoice Amount</th>
                <th class="text-right">Adjusted Amount</th>
                <th class="text-right">Adjust Amount</th>
                <th class="text-right">Balance Amount</th>
                <th class="text-center">Select</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let inv of invoices_list; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ inv.INVOICE_NO }}</td>
                <td>{{ inv.INVOICE_DATE | date:'dd-MM-yyyy' }}</td>
                <td class="text-right">{{ inv.NET_AMOUNT | number:'1.2-2' }}</td>
                <td class="text-right">{{ inv.INVOICE_AMOUNT | number:'1.2-2' }}</td>
                <td class="text-right">
                    <input type="number" [(ngModel)]="inv.adjust_amount" class="form-control text-right" [readonly]="!inv.checked" (input)="recalculateTotal()" />
                </td>
                <td class="text-right">{{ (inv.INVOICE_AMOUNT - (inv.adjust_amount || 0)) | number:'1.2-2' }}</td>
                <td class="text-center">
                    <input type="checkbox" [(ngModel)]="inv.checked" (change)="recalculateTotal()" />
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td colspan="4" class="text-right"><strong>Total Adjusted:</strong></td>
                <td class="text-right"><strong>{{ total_adjusted | number:'1.2-2' }}</strong></td>
                <td class="text-right"><strong>{{ getTotalBalance() | number:'1.2-2' }}</strong></td>
                <td></td>
            </tr>
            </tfoot>
        </table>
    </div>

    <!-- Save / Cancel -->
    <div class="row container mt-3">
        <div class="col-lg-12 text-right">
            <button (click)="saveReceipt()" *ngIf="user_rights.ADD=='1'" class="btn btn-info btn-sm">
                {{ receipts.edit_status ? 'Update' : 'Save' }}
            </button>
            &nbsp;&nbsp;
            <button (click)="clear()" *ngIf="user_rights.ADD=='1'" class="btn btn-warning btn-sm">Cancel</button>
        </div>
    </div>
</div>


<div class="mt-5 mb-5">
        <h4 class="list-header mb-3"><i class="fas fa-list"></i> Receipts List</h4>
        <table class="table table-hover table-striped table-bordered">
            <thead>
            <tr>
                <th>#</th>
                <th class="text-left">Receipt No</th>
                <th class="text-left">Date</th>
                <th class="text-left">Customer Name</th>
                <th class="text-left">Receipt Type</th>
                <th class="text-right">Amount</th>
<!--                <th class="text-center">Action</th>-->
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of receipt_list; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ data.RECEIPT_NO }}</td>
                <td>{{ data.FORMATED_DATE }}</td>
                <td>{{ data.CUSTOMER_NAME }}</td>
                <td>{{ data.RECEIPT_TYPE }}</td>
                <td class="text-right">{{ data.RECEIPT_AMOUNT }}</td>
<!--                <td class="text-center">-->
<!--                    <button-->
<!--                            (click)="edit_payment(data)"-->
<!--                            class="btn btn-success btn-sm mb-2"-->
<!--                            title="Edit"-->
<!--                            type="button"-->
<!--                    >-->
<!--                        <i class="fa fa-edit" style="color: white;"></i>-->
<!--                    </button>-->
<!--                    &nbsp;-->
<!--                    <button-->
<!--                            (click)="delete_payment(data.PAYMENT_ID)"-->
<!--                            class="btn btn-danger btn-sm mb-2"-->
<!--                            title="Delete"-->
<!--                            type="button"-->
<!--                    >-->
<!--                        <i class="fa fa-trash" style="color: white;"></i>-->
<!--                    </button>-->
<!--                </td>-->
            </tr>
            </tbody>
        </table>
    </div>
